import { useEffect, useState } from "react";
import OuterBlueC from "@/assets/CarlineConsensor-Primary-Square-OuterBlueCNew.svg";
import RedSteer from "@/assets/CarlineConsensor-Primary-Square-RedSteerNew.svg";
import InnerYellowC from "@/assets/CarlineConsensor-PrimarySquare-InnerYellowCNew.svg";

const logoSources = [OuterBlueC, RedSteer, InnerYellowC];

let preloadPromise: Promise<boolean> | null = null;
let cachedReady = false;

const loadImage = (src: string) =>
  new Promise<void>((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error(`Failed to load: ${src}`));
    img.src = src;
  });

const ensurePreloaded = (): Promise<boolean> => {
  if (cachedReady) return Promise.resolve(true);
  if (!preloadPromise) {
    preloadPromise = Promise.all(logoSources.map(loadImage))
      .then(() => {
        cachedReady = true;
        return true;
      })
      .catch((error) => {
        console.error('Logo preload failed:', error);
        // Reset so we can retry next time
        preloadPromise = null;
        cachedReady = false;
        return false;
      });
  }
  return preloadPromise;
};

export const useLogoPreload = () => {
  const [ready, setReady] = useState(cachedReady);

  useEffect(() => {
    if (ready) return;

    let mounted = true;
    ensurePreloaded().then((success) => {
      if (mounted && success) setReady(true);
    });

    return () => {
      mounted = false;
    };
  }, [ready]);

  return ready;
};
